'use client'

import SigninForm from '@/components/pages/auth/signin/SigninForm'
// import AuthButtonsList from '@/components/shared/AuthButtons/AuthButtonsList'
import Title from '@/components/ui/Title'
import { STORAGE_KEYS } from '@/constants/storage/keys'
// import Link from 'next/link'
import { useEffect, useState } from 'react'

export default function Signin() {
  const [isOTPScreen, setOTPScreen] = useState<boolean>(false)

  useEffect(() => {
    const userRegion = localStorage.getItem(STORAGE_KEYS.USER_REGION)
    if (userRegion) {
      localStorage.removeItem(STORAGE_KEYS.USER_REGION)
    }
  }, [])

  const handleGoToOTP = () => {
    setOTPScreen(true)
  }

  return (
    <div className='w-full px-4 md:max-w-[480px] lg:max-w-[47%] md:px-0'>
      <Title
        tag='h3'
        text='Sign In'
        className='-mb-6 text-left !text-[28px] font-semibold !leading-[34px]'
      />
      {/* <div className='flex items-center justify-center gap-2 text-center'>
        <p className='text-gray-500'>Don&apos;t have an account ?</p>
        <Link
          href={'/agency/signup'}
          className='text-sm font-medium text-ui-black underline'
        >
          Sign up
        </Link>
      </div> */}
      <SigninForm
        isOTPScreen={isOTPScreen}
        handleGoToOTP={handleGoToOTP}
        type={'page'}
        openSignupModal={() => {}}
      />
      {/* {!isOTPScreen && <AuthButtonsList />} */}
    </div>
  )
}